import {inject, Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

import {Observable} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {ToastAlertSignalStore} from '../../../store/alert/toast-alert.signal-store';
import {ToastAlert} from '../../../model/toast-alert.model';
import {PageSignalStore} from '../../../store/page/page.signal-store';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class GeneralInterceptor implements HttpInterceptor {
  errorCodeWhitelist: string[] = ['error.mail.recipients', 'error.mail.buyer.recipients',
    'error.mail.custodian.recipients', 'error.mail.buyerAndCustodian.recipients'];
  readonly toastAlertStore = inject(ToastAlertSignalStore);
  private readonly translate = inject(TranslateService);
  private readonly pageSignalStore = inject(PageSignalStore);

  intercept(req: HttpRequest<any>, next: HttpHandler):
      Observable<HttpEvent<any>> {
    let httpError: HttpErrorResponse;

    return next.handle(req)
      .pipe(
        tap({
          next: () => {},
          error: error => {
            httpError = error;
          }
        }),
        finalize(() => {
          if (httpError?.error) {
            const errors = httpError.error;
            if (!this.isWhitelistErrorCode(errors)) {
              this.fallbackDisableSpinner();
              this.handleErrors(errors, httpError);
            }
          }
        })
      );
  }

  handleErrors(errors, httpError) {
    switch (true) {
    case errors.errors:
      this.handleDetailedErrors(errors);
      break;
    case errors.globalErrors:
      this.handleGlobalErrors(errors);
      break;
    default:
      this.handleHttpError(httpError);
      break;
    }
  }

  handleDetailedErrors(errors) {
    for (const err of errors.errors) {
      this.toastAlertStore.addToastAlert(new ToastAlert('danger', this.translate.instant(err.code) +
          ' (Support-ID: ' + errors.reference + ')'));
    }
  }

  handleGlobalErrors(errors) {
    for (const err of errors.globalErrors) {
      this.toastAlertStore.addToastAlert(new ToastAlert('danger', this.translate.instant(err.code) +
          ' (Support-ID: ' + errors.reference + ')'));
    }
  }

  handleHttpError(httpError) {
    this.toastAlertStore.addToastAlert(new ToastAlert('danger', httpError.error.message));
  }

  /**
   * just in case the spinner state was set true directly without using the spinner service
   */
  fallbackDisableSpinner(): void {
    this.pageSignalStore.updateLoading(false);
  }

  /**
   * Checks if the error code of the error is on the whitelist of error Codes
   * @param error the error you want to check
   */
  isWhitelistErrorCode(error: any) {
    return this.errorCodeWhitelist.includes(error.code);
  }
}
